export var scrollToView = function scrollToView(id, options) {
  var element = document.getElementById(id);
  setTimeout(function () {
    if (element) element.scrollIntoView(options || {
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  }, 300);
};